import { useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './AuthPrompt.css';

export default function ConfirmSignup() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const confirmSignup = async () => {
      const token = searchParams.get('token');
      const type = searchParams.get('type');
      
      if (token && type === 'signup') {
        try {
          const { error } = await supabase.auth.verifyOtp({
            type,
            token_hash: token
          });
          
          if (error) throw error;
          
          // Success! Redirect to welcome page
          navigate('/welcome');
        } catch (error) {
          console.error('Confirmation error:', error);
          navigate('/signup-error');
        }
      }
    };
    
    confirmSignup();
  }, [searchParams, navigate]);

  return (
    <div className="auth-container">
      <h2>Confirming your signup...</h2>
      <p>Please wait while we verify your email address.</p>
    </div>
  );
}